import React, { useEffect } from 'react';

export default props => {
    let name = 'editor_' + props.id;

    useEffect(() => {
        console.log('useEffect');

        if (typeof window.CKEDITOR === 'undefined') {
            $('head').append($('<script />', {
                src: '/assets/js/vendors/ckeditor/ckeditor.js',
                async: true
            }));
        }

        // re-bind ckeditor
        CKEDITOR.replace(name, {});

        // register listener for custom events if any
        for (let e in props.events) CKEDITOR.instances[name].on(e, props.events[e]);

    }, []);

    return (
        <React.Fragment>
            <p className="label label-ckeditor">{props.label}</p>
            <textarea name={name} defaultValue={props.value}></textarea>
        </React.Fragment>
    )
}